/**
 * src/lib/auth/roles.js — client mirror of the server role hierarchy (Section 6).
 * The client uses this to SHAPE and GUARD views; the API independently enforces
 * the same hierarchy for privileged actions. Both layers must agree.
 */
export const ROLE_LEVEL = {
  PATIENT: 10, RESEARCHER: 15, LAB_TECH: 20, NURSE: 25,
  PATHOLOGIST: 30, HEMATOLOGIST: 30, PHYSICIAN: 30,
  INSTITUTION_ADMIN: 60, COMPLIANCE_OFFICER: 70, ADMIN: 90, SUPER_ADMIN: 100,
};

export const TIER_LEVEL = { FREE: 0, BASIC: 1, PRO: 2, ENTERPRISE: 3 };

export const ROLE_LABELS = {
  SUPER_ADMIN: 'Super Admin', ADMIN: 'Administrator', COMPLIANCE_OFFICER: 'Compliance Officer',
  INSTITUTION_ADMIN: 'Institution Admin', PHYSICIAN: 'Physician', HEMATOLOGIST: 'Hematologist',
  PATHOLOGIST: 'Pathologist', NURSE: 'Nurse', LAB_TECH: 'Lab Technician',
  RESEARCHER: 'Researcher', PATIENT: 'Patient',
};

export const roleAtLeast = (role, required) =>
  (ROLE_LEVEL[role] || 0) >= (ROLE_LEVEL[required] || 0);

export const tierAtLeast = (tier, required) =>
  (TIER_LEVEL[String(tier || '').toUpperCase()] || 0) >= (TIER_LEVEL[String(required || '').toUpperCase()] || 0);
